var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgIconChevronRightV1 = function SvgIconChevronRightV1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.394 5.5L13 10l-4.606 4.5a1.904 1.904 0 0 1 0-2.724L10.212 10 8.394 8.224a1.904 1.904 0 0 1 0-2.724z"
  })));
};
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgPHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNOC4zOTQgNS41TDEzIDEwbC00LjYwNiA0LjVhMS45MDQgMS45MDQgMCAwIDEgMC0yLjcyNEwxMC4yMTIgMTAgOC4zOTQgOC4yMjRhMS45MDQgMS45MDQgMCAwIDEgMC0yLjcyNHoiLz4NCjwvc3ZnPg0K";
export { SvgIconChevronRightV1 as ReactComponent };